var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-logo-container"},[_c('router-link',{staticClass:"a-logo-content",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":"logo","width":"32","height":"32"}}),_c('div',{staticClass:"a-logo-title",class:{
        'a-logo-content-light': _vm.type === 'Home',
      },attrs:{"data-cy":"title"}},[_c('i',[_vm._v("Prismlab")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }